import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import { authApi } from "@api";
import { ComponentHeaderAuth, ComponentSignUpOTP } from "@components";
import { enumValidation, PATH_HOME, TIME_RESEND } from "@configs";
import { IAuthConfig } from "@interfaces";
import {
    addConfigClient,
    selectConfigClient,
    selectMerchant,
    setAuth,
    setConfigClient,
    setFromLogin,
    setLoading,
    setPreformFields,
} from "@redux";
import { formatMessage, useNotify } from "@utils";

export const PageSignUpOTP = () => {
    //page hook
    const history = useHistory();
    const { error, success } = useNotify();
    const dispatch = useDispatch();
    //page state
    const [otp, setOtp] = useState<string>("");
    const [timeResend, setTimeResend] = useState<number>(TIME_RESEND);
    //redux state
    const configClient = useSelector(selectConfigClient);
    const { _id } = useSelector(selectMerchant);
    //page variable
    const phoneNumber = window.sessionStorage.getItem("phoneNumber") || "";
    const remember = window.sessionStorage.getItem("remember");

    const handleChangeOtp = (newotp: string) => {
        setOtp(newotp);
        if (newotp.length === 6) {
            handleVerifyOtp(newotp);
        }
    };

    const handleVerifyOtp = async (outotp: string) => {
        if (outotp.length < enumValidation.LENTH_OTP) return;
        try {
            dispatch(setLoading(true));
            const res = await authApi.verifyPhone({
                phoneNumber,
                code: outotp,
            });
            const data = res.data.token as IAuthConfig;
            const message = res.data.message;

            const authData = remember
                ? { ...data, merchantId: _id || "" }
                : { ...data, refreshToken: null, merchantId: _id || "" };
            dispatch(setAuth(authData));
            dispatch(setPreformFields(res.data.preformFields));
            if (_id) {
                const index = configClient.findIndex((item) => item.merchantId === _id);
                if (index >= 1) {
                    dispatch(
                        setConfigClient({
                            index,
                            configClient: {
                                merchantId: _id || "",
                                token: authData,
                            },
                        })
                    );
                } else {
                    dispatch(
                        addConfigClient({
                            merchantId: _id || "",
                            token: authData,
                        })
                    );
                }
                success(message);
                history.push(PATH_HOME);
                dispatch(setFromLogin(true));
            }
        } catch (errors: any) {
            // const { message } = errors.response.data;
            if (errors.response) {
                error(formatMessage(errors.response));
            }
        } finally {
            dispatch(setLoading(false));
        }
    };

    const handleResend = async () => {
        if (timeResend !== TIME_RESEND) return;
        try {
            dispatch(setLoading(true));
            const res = await authApi.resendPhone({
                phoneNumber,
            });
            if (res.data.message) {
                success(res.data.message);
                let currentTime = timeResend;
                const id = setInterval(() => {
                    currentTime = currentTime - 1;
                    setTimeResend(() => currentTime);
                    if (currentTime === 0) {
                        setTimeResend(TIME_RESEND);
                        clearInterval(id);
                    }
                }, 1000);
            }
        } catch (errors: any) {
            // const { message } = errors.response.data;
            if (errors.response) {
                error(formatMessage(errors.response));
            }
        } finally {
            dispatch(setLoading(false));
        }
    };

    return (
        <ComponentHeaderAuth>
            <ComponentSignUpOTP
                handleVerifyOtp={handleVerifyOtp}
                handleChangeOtp={handleChangeOtp}
                handleResend={handleResend}
                otp={otp}
                timeResend={timeResend}
            />
        </ComponentHeaderAuth>
    );
};
